import moment from "moment";
import { valueIsObject } from "../formGenUtils/getYupValidator";
import { IncidentStatus } from "../../types/fieldInstance.interface";
import { FormAction } from "../../store/incident/reducer";
import { buildIncidentOriginState } from "./incidentNavigation";

export function getFormattedIncidentsData(arr: any[]) {
  if (!arr?.length) return arr;
  else
    return arr.map((obj: any) => {
      const FacilityName = obj?.Facility__r?.Name || "Not available";
      // FacilityDateTime is the date/time the nurse entered
      const FacilityDateTime = obj?.Incident_Date_Time__c || "Not available";
      const type = obj?.RecordType?.Name || undefined;
      const incidentCreatedBy = obj?.Incident_Created_By__r?.Name || "-";

      return {
        ...obj,
        FacilityName,
        FacilityDateTime,
        type,
        incidentCreatedBy,
      };
    });
}

export function getFormattedDraftIncidentsData(
  arr: any,
  facilities: any[],
  incidentTypes: any[]
) {
  if (!arr?.length) return arr;
  else
    return arr.map((_incident: any) => {
      let transformedIncidentObject;
      let incident: {
        Facility__c: any;
        Incident_Date_Time__c: any;
        RecordTypeId: any;
        Draft_Created_By__c: any;
        incidentStatus: any;
        residentName: any;
      };
      try {
        transformedIncidentObject = JSON.parse(_incident.Incident_Json__c);
        incident = {
          ...transformedIncidentObject.incident,
          Id: _incident.Id,
        };
        return {
          ...incident,
          Name: _incident.Name, 
          FacilityName:
            facilities.find(
              (facility: { facilityId: any }) =>
                incident?.Facility__c === facility.facilityId
            )?.facilityName || "_",
          CreatedAtDate: _incident?.CreatedDate
            ? moment(_incident?.CreatedDate).format("DD MMM YYYY")
            : "-",
          FacilityDateTime: incident?.Incident_Date_Time__c,
          type:
            incidentTypes.find((i) => i.flag === incident?.RecordTypeId)
              ?.label || "-",
          incidentCreatedBy: incident?.Draft_Created_By__c || " - ",
          Incident_Status__c: incident?.incidentStatus || " - ",
          Resident_Name__c: incident?.residentName || "-",
          idempotencyKey: _incident?.Idempotency_Key__c,
        };
      } catch (error: any) {
        console.error("Parsing error:", error?.message);
        return _incident;
      }
    });
}

export const getObjectValues = (data: any) => {
  if (valueIsObject(data) && data.Id) {
    return data.Id;
  } else {
    return data;
  }
};

export const doHandleTransform = (data: any) => {
  return Object.keys(data).reduce((acc: any, fieldName: any) => {
    acc[fieldName] = getObjectValues(data[fieldName]);
    return acc;
  }, {});
};

export const viewClickedIncident = (
  createForm: (payload: string) => void,
  updateForm: (id: string, arg1: FormAction) => void,
  selectedIncident: any,
  incidentType: { id: any },
  navigate: (path: string, options?: { state?: any }) => void,
  shouldNavigate: boolean = true
) => {
  createForm(selectedIncident?.Id);
  const status = Object.values(IncidentStatus).find(
    (status) => selectedIncident.Incident_Status__c === status
  );
  updateForm(selectedIncident?.Id, {
    type: "UPDATE_FORM_STATE",
    payload: {
      incidentStatus: status ?? selectedIncident.Incident_Status__c,
      markedAsHighSeverity: selectedIncident.Mark_as_High_Severity__c,
    },
  });
  updateForm(selectedIncident?.Id, {
    type: "UPDATE_BASE_FORM_DATA",
    payload: {
      incidentType: incidentType.id,
      facilityId: selectedIncident?.Facility__c,
    },
  });
  // Record the originating screen so exiting the incident returns to it.
  shouldNavigate &&
    navigate(
      `/incidents/${selectedIncident?.Id}/patient-demographics?mode=view`,
      { state: buildIncidentOriginState(window.location) }
    );
};
